import { fontsMetaData } from '@wix/thunderbolt-fonts'

export function getFontFamilyWithFallbacks(fontFamily: string): string {
	if (!fontFamily) {
		return ''
	}

	const cleanFontName = fontFamily.replace(/\+/g, ' ').toLowerCase()
	const [highestPriorityFont] = cleanFontName.split(',')
	const metaData = fontsMetaData[highestPriorityFont]
	if (!metaData) {
		return fontFamily
	}
	return [highestPriorityFont, metaData.fallbacks, metaData.genericFamily].filter((t) => t).join(',')
}
